/* eslint-disable @typescript-eslint/no-explicit-any */
export default <T>(
  funcOrValue: T,
  ...args: T extends (...args: infer A) => any ? A : never[]
): T extends (...args: any[]) => infer R ? R : T =>
  typeof funcOrValue === 'function'
    ? funcOrValue(...args)
    : (funcOrValue as T extends (...args: any[]) => infer R ? R : T);
